import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import content from 'prismic-translates/dialog-sc-request-code.json'
import Loader from 'src/components/Loader'

import classes from '../styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  scCode: string
  isLoading: boolean
}

export default function RecivedCode(props: Props) {
  return (
    <>
      <p className='mt-typography-body1'>{t('step3_part1')}</p>

      {props.isLoading ? (
        <Loader />
      ) : (
        <h5 className={`mt-typography-h5 ${classes.code}`}>
          <b>{props.scCode}</b>
        </h5>
      )}

      <p className='mt-typography-body1'>{t('step3_part2')}</p>
    </>
  )
}
